import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Layouts } from "../../app.component";
import { PropertyViewComponent } from "./property-view.component";
import { DataTypeComponent } from "../data-type/data-type.component";

const routes: Routes = [
  {
    path: "data-catalogue/:catId/property/:propertyId",
    component: PropertyViewComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "data-catalogue/data-type/:dataType",
    component: DataTypeComponent,
    data: { layout: Layouts.SecureLayout },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PropertyViewRoutingModule {}
